export default __webpack_public_path__ + "static/logo-vert-brown-0fbf7aabbadef6744970023a0dda3581.svg";